// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__PCYRo","placeholder":"styles_placeholder__Brd9x","icon":"styles_icon__u_ZtY","iconSelect":"styles_iconSelect__f1hcB","menuItem":"styles_menuItem__zVOqo"};